$(document).ready(function() {
    $("body").on(
        "click",
        "#" + memberFormTabsSettings.buttons.backButton,
        function() {
            var tabForm = require("../tabForm");
            tabForm.goBacK(memberFormTabsSettings);
        }
    );
});
var moment = require("moment");
const { GENDER_TYPE } = require("../app");
var memberFormTabsSettings = {
    tabsCount: 3,
    leftTabMainwrappers: "guide-tabs",
    mainWrappersClassName: "formTabWrappers",
    formIdName: "addMemberForm",
    feedBoxIdName: "add-member-form-feed",
    buttons: {
        backButton: "addMemberPrevTabBtn",
        addEditButton: "mb-pkg-addedit",
    },
    fields: {
        basicDetails: {
            leftLink: "mb-lt-basic",
            with: [1],
            fields: {},
        },
        packageDetailsTmp: {
            leftLink: "tab-pkg-details",
            with: [1],
            fields: {},
        },
        payments: {
            leftLink: "tab-mb-payments",
            with: [1],
            fields: {},
        },
    },
};

var requiredField = {
    required: true,
    messages: {
        required:
            "<i class='fa fa-info-circle' aria-hidden='true'></i> required",
    },
};
var initActivationDate;
var viewPackages = $("#addMember").data("packages");

window.addMember = new Vue({
    el: "#addMember",
    props: ["canCreateLiability", "canCreateTransfer"],
    data: {
        memberData: {
            leadCode: "",
            user: { email: "", mobile: "", code: "", callingCode: "" },
            dateOfPayment: moment().format("DD/MM/YYYY"),
            activationDate: moment().format("DD/MM/YYYY"),
            dob: "",
        },
        genderList: GENDER_TYPE,
        packagePaymentDetails: {},
        allPackageTypeList: [],
        allPackageList: [],
        allPackageTrainerList: [],
        packageTypeList: [],
        selectedPackageType: [],
        selectedPackage: [],
        selectedPackageTrainer: [],
        selectedSalesRep: [],
        selectedPackageList: {},
        headerMessage: "Add Member",
        type: "add",
        errorMessage: "",
        couponApplyMessage: "",
        packageList: {},
        show: false,
        couponApplied: false,
        selectedItems: {
            gender: [],
            packageType: [],
            packageName: [],
            packageTrainer: [],
            coupon: [],
            paymentMode: [],
            transfer: {
                paymentMode: [],
            },
        },
        memberVerificationError: "",
        couponList: [],
        paymentList: [
            { id: "cash", name: "Cash" },
            { id: "card", name: "Card" },
            { id: "cheque", name: "Cheque" },
            { id: "paytm", name: "Paytm" },
            { id: "payu", name: "PayU" },
            { id: "paymentlink", name: "PaymentLink" },
            { id: "mobikwik", name: "MobiKwik" },
            { id: "jiomoney", name: "JioMoney" },
            { id: "tez", name: "Tez" },
            { id: "freecharge", name: "Freecharge" },
            { id: "neft", name: "NEFT" },
            { id: "imps", name: "IMPS" },
            { id: "upi", name: "UPI" },
        ],
        packageEditType: false,
        partial: false,
        partPayment: "",
        sendTNC: false,
        sendLiability: false,
        cgst: 9,
        sgst: 9,
        paymentNote: "",
        centerTncAvailable: false,
        centerLiabilityAvailable: false,
        transfer: {
            payTransferFee: false,
            amount: "",
            editGst: false,
            reference: "",
            date: "",
            mode: "",
            cgst: 9,
            sgst: 9,
        },
        upgradePackgeInfo: {
            upgradePackageArray: [
                {
                    id: "1",
                    name: "11",
                },
                {
                    id: "2",
                    name: "22",
                },
            ],
            selectedUpgradePackage: [],
            upgradePackage: [],
            packageType: "",
            packageName: "",
            totalAmount: 0,
            paidAmount: 0,
            dueAmount: 0,
            balanceAmount: 0,
            userPackageCode: "",
            currentPayableAmount: 0,
        },
        showBtnLoading: false,
        emergencyContact: false,
        emergency: { email: "", contact: "" },
        callingCodeEmergencyContact: "",
        country: {
            callingCode: "+91",
        },
        emergencyCallingCode: {
            callingCode: "+91",
        },
        countryList: [],
    },
    filters: {
        formatValidityType: function(type) {
            switch (parseInt(type)) {
                case 1:
                    typeStr = "Month";
                    break;
                case 2:
                    typeStr = "Week";
                    break;
                case 3:
                    typeStr = "Day";
                    break;
            }
            typeStr += parseInt(type) > 1 ? "s" : "";
            return typeStr;
        },
    },
    mounted: function() {
        $(".multiselect__input").each(function() {
            var input = $(this);
            input
                .closest(".multiselect")
                .attr("id", input.attr("id") + "-multiselect");
        });
        $(".multiselect__single").each(function() {
            var input = $(this);
            var multiselectDiv = input.closest(".multiselect");
            multiselectDiv.attr(
                "id",
                multiselectDiv.data("id") + "-multiselect"
            );
        });

        var calculateMinMaxDates = function(dp, $input) {
            var inputModel = $input.data("model");
            var isAdmin = $("#addMember").data("isAdmin");

            if (initActivationDate === undefined) {
                initActivationDate = null;
            }
            //            if (inputModel == 'activationDate' && addMember.type == 'renewPackage' && initActivationDate === null) {
            //                initActivationDate = addMember.memberData.activationDate
            //            }
            //            if (addMember.type !== 'renewPackage') {
            //                initActivationDate = null;
            //            }
            if (inputModel != "transferPaymentDate") {
                console.log("transer yes");
                var setMaxDate =
                        inputModel != "paymentDueDate" &&
                        addMember.type != "renewPackage" &&
                        inputModel != "activationDate"
                            ? new Date()
                            : false,
                    setMinDate =
                        inputModel == "paymentDueDate"
                            ? new Date()
                            : initActivationDate !== null
                            ? moment(initActivationDate, "DD/MM/YYYY").toDate()
                            : false;
            } else {
                console.log("transer No");
                console.log(isAdmin);
                var setMaxDate = isAdmin ? false : 0,
                    setMinDate = isAdmin ? false : 0;
            }
            $input.datetimepicker("setOptions", {
                maxDate: setMaxDate,
                minDate: setMinDate,
            });
            // if (
            //     addMember.type == "transferPackage" &&
            //     inputModel == "activationDate"
            // ) {
            //     $input.datetimepicker("destroy");
            // }
        };

        $("#addMember").on("shown.bs.modal", function(e) {
            addMember.getAllPackageTypeList();
            addMember.getAllTrainerList();
            addMember.checkCenterLiability();
            addMember.checkCenterTnc();
            setTimeout(function() {
                $(".addMemberDatepickerApp")
                    .datetimepicker({
                        format: "d/m/Y",
                        timepicker: false,
                        scrollInput: false,
                        onChangeDateTime: function(dp, $input) {
                            console.log($input);
                            var inputModel = $input.data("model");
                            addMember.memberData[inputModel] = $input.val(); //moment($input.val(), "DD/MM/YYYY").format("YYYY-MM-DD");
                        },
                        onShow: function(dp, $input) {
                            console.log($input);
                            calculateMinMaxDates(dp, $input);
                        },
                    })
                    .attr("readOnly", "true")
                    .css({
                        background: "white",
                        color: "#232531",
                    });

                $(".date-icon").on("click", function() {
                    $(this)
                        .prev(".form-control")
                        .focus();
                });

                $(".addMemberDatepickerApp").each(function() {
                    $input = $(this);
                    if (
                        $input.data("model") == "activationDate" &&
                        addMember.type == "renewPackage"
                    ) {
                        $input.datetimepicker("setOptions", {
                            value: moment(
                                addMember.memberData.activationDate,
                                "DD/MM/YYYY"
                            ).toDate(),
                        });
                    } else if ($input.data("model") == "dob") {
                        $input.datetimepicker("setOptions", {
                            value: "",
                        });
                    } else if ($input.val()) {
                        addMember.memberData[
                            $input.data("model")
                        ] = $input.val();
                    }
                    calculateMinMaxDates($(this).val(), $(this));
                });
            }, 100);
            setTimeout(function() {
                $(".multiselect__input").each(function() {
                    var input = $(this);
                    input
                        .closest(".multiselect")
                        .attr("id", input.attr("id") + "-multiselect");
                });
                $(".multiselect__single").each(function() {
                    var input = $(this);
                    var multiselectDiv = input.closest(".multiselect");
                    multiselectDiv.attr(
                        "id",
                        multiselectDiv.data("id") + "-multiselect"
                    );
                });
            }, 100);
        });
        $("#addMember").on("hidden.bs.modal", function(e) {
            // moved to a functionn as mounted is not getting initialized for assign member pop up
            //addMember.resetAddMemberForm();
        });

        $(".autoCapitalize").keyup(function() {
            var string = $(this).val();
            $(this).val(string.charAt(0).toUpperCase() + string.slice(1));
        });
        setTimeout(function() {
            $(".addMemberDatepickerApp").datetimepicker({
                format: "d/m/Y",
                timepicker: false,
                scrollInput: false,
                onChangeDateTime: function(dp, $input) {
                    var inputModel = $input.data("model");
                    addMember.memberData[inputModel] = $input.val(); //moment($input.val(), "DD/MM/YYYY").format("YYYY-MM-DD");
                },
            });
            $(".addMemberDatepickerApp").each(function() {
                if ($(this).val() != "") {
                    addMember.memberData[$(this).data("model")] = $(this).val();
                }
            });
        }, 100);
        $("body").on("click", ".mbPkgActivityClose a", function() {
            $("#selectPackageBox").hide();
            $("#addMorePackage").removeClass("hide");
        });
        $(document).on("keyup focusout", "#memEmail", function() {
            var emailValidation = $(this).valid();
            if (!emailValidation) {
                $("#mem-email-mobile-err").empty();
                $("#mem-email-mobile-err").html($("#memEmail-error").html());
                $("#memEmail-error").remove();
            } else {
                $("#mem-email-mobile-err").empty();
                $("#memEmail-error").remove();
            }
        });
        $(document).on("keyup focusout", "#memMobile", function() {
            var mobileValidation = $(this).valid();
            if (!mobileValidation) {
                $("#mem-email-mobile-err").empty();
                $("#mem-email-mobile-err").html($("#memMobile-error").html());
                $("#memMobile-error").remove();
            } else {
                $("#mem-email-mobile-err").empty();
                $("#memMobile-error").remove();
            }
        });
        this.getCountryList();
    },
    methods: {
        getCountryList() {
            this.$http.get("/country/list").then((response) => {
                this.countryList = response.body.result;
            });
        },
        onCountryCodeChange: function(value) {
            console.log(value);
        },
        editGstPercentage: function() {
            var isChecked = $(".editGstCheckbox").is(":checked");
            if (isChecked) {
                $(".gstPercentage").removeAttr("readonly");
            } else {
                $(".gstPercentage").attr("readonly", true);
                this.cgst = 9;
                this.sgst = 9;
            }
        },
        validateMemberUser: function() {
            if (
                $.trim(
                    this.memberData.user.mobile +
                        "" +
                        this.memberData.user.email
                ) == ""
            ) {
                this.memberVerificationError = "";
                return false;
            }
            this.$http
                .get(
                    "/user/details/bymobileemail?mobile=" +
                        $.trim(this.memberData.user.mobile) +
                        "&email=" +
                        $.trim(this.memberData.user.email) +
                        "&callingCode=" +
                        $.trim(this.memberData.user.callingCode)
                )
                .then((response) => {
                    if (response.body.hasError) {
                        if (
                            this.memberData.user.email &&
                            this.memberData.user.mobile
                        ) {
                        } else if (this.memberData.user.mobile) {
                            this.memberData.user.email = "";
                        } else if (this.memberData.user.email) {
                            this.memberData.user.mobile = "";
                            this.memberData.user.callingCode = "";
                        }
                        this.memberVerificationError = response.body.message;
                        return false;
                    }
                    var result = response.body.result;
                    if (result.user) {
                        if (result.user.email) {
                            this.memberData.user.email = result.user.email;
                        }
                        if (result.user.mobile) {
                            this.memberData.user.mobile = result.user.mobile;
                            this.memberData.user.callingCode =
                                result.user.callingCode;
                        }
                        if (result.user.firstName) {
                            this.memberData.name = result.user.firstName;
                        }
                        if (result.user.dob) {
                            if (moment(result.user.dob).isValid()) {
                                this.memberData.dob = moment(
                                    result.user.dob
                                ).format("DD/MM/YYYY");
                            }
                        }
                        if (result.user.gender) {
                            this.memberData.gender = result.user.gender;
                            this.selectedItems.gender = $.map(
                                this.genderList,
                                function(item, index) {
                                    if (
                                        item.id.toLowerCase() ===
                                        result.user.gender.toLowerCase()
                                    ) {
                                        return item;
                                    }
                                }
                            );
                        }
                        if (
                            this.type != "transferPackage" &&
                            result.user.member.isMember === true
                        ) {
                            toastr["error"]("Member Already Exists");
                            $("#mb-pkg-addedit").prop("disabled", true);
                        } else if (
                            this.type == "transferPackage" &&
                            result.user.member.isMember === true
                        ) {
                            if (
                                result.user.code == appMemberDetails.memberCode
                            ) {
                                toastr["error"](
                                    "Cannot transfer packages to the same member"
                                );
                            } else {
                                this.memberData.user.code = result.user.code;
                            }
                        } else {
                            $("#mb-pkg-addedit").prop("disabled", false);
                            this.memberData.user.code = "";
                        }
                        this.memberVerificationError = "";
                    } else {
                        if (
                            this.memberData.user.email &&
                            this.memberData.user.mobile
                        ) {
                        } else if (this.memberData.user.mobile) {
                            this.memberData.email = "";
                            $("#name").val("");
                            $("#memberdob").val("");
                        } else if (this.memberData.user.email) {
                            this.memberData.mobile = "";
                            $("#name").val("");
                            $("#memberdob").val("");
                        }
                        this.memberVerificationError = "";
                        $("#mb-pkg-addedit").prop("disabled", false);
                    }
                });
        },
        addPackeToBucket: function() {
            var errorMsg = {
                required: true,
                messages: {
                    required:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Required",
                },
            };
            var packageType = this.selectedItems.packageType.id;
            var packageCode = this.selectedItems.packageName.code;
            var packagePayableAmount = Math.round(
                this.selectedItems.packageName.price
            );
            var packageTrainerCode = this.selectedItems.packageTrainer.code;

            var minPayableAmount =
                parseFloat(this.selectedItems.packageName.price) -
                parseFloat(this.selectedItems.packageName.maxDiscountAllowed);
            var maxPayableAmount = parseFloat(
                this.selectedItems.packageName.price
            );

            var errorMsgInvalidPrice = {
                number: true,
                max: Number(addMember.memberData.packageMaxDiscount),
                messages: {
                    max:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Should not exceed" +
                        Vue.options.filters.convertCurrency(
                            this.memberData.maxDiscountAvailable
                        ),
                    number:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Invalid Price",
                },
            };
            var currTab = $("#guide-tabs li.active a").data("target");
            var customValidateElements = $(
                "#addMember #" + currTab + " div.multiselect"
            ).map(function(i, element) {
                if (
                    $(element).data("optional") === undefined ||
                    $(element).data("optional") == false
                ) {
                    return $(element)
                        .find("input")
                        .attr("id");
                }
            });

            var isValid = validate.formIsValid("addMemberForm", true);

            $("#packageDiscountAmount").rules("add", errorMsgInvalidPrice);
            var payableisValid = $("#packageDiscountAmount").valid();

            var customValidate = validate.customValidateMultiSelect(
                customValidateElements
            );

            if (
                !(isValid && customValidate && payableisValid) ||
                packagePayableAmount == "" ||
                packagePayableAmount == null
            ) {
                return false;
            }

            if (
                this.type !== "upgradePackage" &&
                (this.memberData.packagePayableAmount < minPayableAmount ||
                    packageType == "" ||
                    packageType == null ||
                    packageCode == "" ||
                    packageCode == null ||
                    packageTrainerCode == "" ||
                    packageTrainerCode == null ||
                    packagePayableAmount == "" ||
                    packagePayableAmount == null)
            ) {
                return false;
            }

            var packageTypeName = this.selectedItems.packageType.name;
            var packageName = this.selectedItems.packageName.name;
            var packageTrainerName = this.selectedItems.packageTrainer
                .firstName;
            var packageActivationDate = this.memberData.activationDate;
            var obj = {
                packageTypeName: packageTypeName,
                packagePrice: this.memberData.packagePrice,
                finalPrice: Math.round(this.memberData.packagePayableAmount),
                packageName: packageName,
                packageCode: packageCode,
                packageTrainerName: packageTrainerName,
                trainerCode: packageTrainerCode,
                activationDate: packageActivationDate,
                couponCode:
                    addMember.selectedItems.coupon.code !== undefined
                        ? addMember.selectedItems.coupon.code
                        : "",
                couponDiscount: addMember.memberData.appliedCouponDiscount,
                additionalDiscount: addMember.memberData.extraDiscount,
                renewedFromUserPackageCode:
                    addMember.memberData.renewedFromUserPackageCode !==
                    undefined
                        ? addMember.memberData.renewedFromUserPackageCode
                        : null,
            };

            if (
                this.packageEditType &&
                obj.packageCode != this.memberData.prevMemberPackageCode
            ) {
                var prevCode = this.memberData.prevMemberPackageCode;
                //Vue.delete(this.selectedPackageList, prevCode);
                $.each(addMember.selectedPackageList, function(
                    key,
                    thisPackage
                ) {
                    if (thisPackage.packageCode == prevCode) {
                        Vue.delete(addMember.selectedPackageList, key);
                        return;
                    }
                });
            }

            var packageKey =
                packageCode +
                "_" +
                Object.keys(this.selectedPackageList).length;
            if (this.packageEditType) {
                $.each(addMember.selectedPackageList, function(
                    key,
                    thisPackage
                ) {
                    if (thisPackage.packageCode === obj.packageCode) {
                        packageKey = key;
                        return;
                    }
                });
            }
            //this.selectedPackageList[packageCode] = obj;
            Vue.set(this.selectedPackageList, packageKey, obj);
            this.selectedItems.packageType = [];
            this.selectedItems.packageName = [];
            this.selectedItems.coupon = [];

            this.allPackageList = [];
            this.couponList = [];

            this.memberData.packagePrice = "";
            this.memberData.packageMaxDiscount = "";
            this.memberData.packagePayableAmount = "";
            this.memberData.appliedCouponDiscount = "";
            this.memberData.activationDate = "";

            $("#packagePrice").val("");
            $("#packageMaxDiscount").val("");
            $("#packagePayableAmount").val("");
            this.populateSelectedPackage();
            $("#packageDiscountAmount").rules("remove");
            $("#packageDiscountAmount").valid();
            $("#selectPackageBox").slideUp("slow");
            $("#addMorePackage").removeClass("hide");
        },
        showPackageInputs: function() {
            this.packageEditType = false;
            $("#selectPackageBox").slideDown("slow");
            $("#addMorePackage").addClass("hide");
            var packageCount = $("#packageAsgnCnt").text();
            if (packageCount > 1) {
                $(".mbPkgActivityClose").removeClass("hide");
            } else {
                if (!$(".mbPkgActivityClose").hasClass("hide")) {
                    $(".mbPkgActivityClose").addClass("hide");
                }
            }
            this.selectedItems.packageType = [];
            this.selectedItems.packageName = [];
            this.selectedItems.coupon = [];
            this.selectedItems.paymentMode = [];
            this.selectedItems.salesRep = [];
            this.memberData.extraDiscount = "";
            addMember.selectedItems.packageTrainer = [];
            this.memberData.activationDate = moment().format("DD/MM/YYYY");
            //$('input [name=activationDate]').date
            $("input[name=activationDate]").datetimepicker("setOptions", {
                value: moment(),
            });
            $("#addMember label.error").hide();
        },
        genderSelect: function(value, id) {
            this.memberData.gender = value.id;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        packageTypeSelect: function(value, id) {
            this.selectedItems.packageName = [];
            this.selectedItems.coupon = [];
            this.memberData.packagePrice = "";
            this.memberData.packageMaxDiscount = "";
            this.memberData.packagePayableAmount = "";
            $("#packageId").val("");
            $("#packagePrice").val("");
            $("#packageMaxDiscount").val("");
            $("#packagePayableAmount").val("");
            this.memberData.packageType = value.id;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
            this.getAllPackageList();
        },
        packageSelect: function(value, id) {
            $("#packagePrice").val("");
            $("#packageMaxDiscount").val("");
            $("#packagePayableAmount").val("");
            this.memberData.packagePrice = "";
            this.memberData.packageMaxDiscount = "";
            this.memberData.packagePayableAmount = "";
            this.memberData.couponCode = "";
            this.memberData.appliedCouponDiscount = 0;
            this.selectedItems.coupon = [];
            if (this.selectedPackageList.hasOwnProperty(value.code)) {
                toastr["error"]("Package Already Assigned");
                setTimeout(function() {
                    addMember.selectedItems.packageName = [];
                }, 100);
                return false;
            }
            this.memberData.prevMemberPackageCode = this.memberData.packageCode;
            this.memberData.packageCode = value.code;

            this.memberData.packagePayableAmount = this.memberData.packagePrice =
                value.price;
            this.memberData.packageMaxDiscount = value.maxDiscountAllowed;
            this.memberData.maxDiscountType = value.maxDiscountType;
            this.memberData.maxDiscountAvailable = value.maxDiscountAllowed;
            this.getPackageCoupon();
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        packageTrainerSelect: function(value, id) {
            this.memberData.trainerCode = value.userCode;
            this.selectedPackageTrainer = value;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        salesRepSelect: function(value) {
            addMember.selectedSalesRep = value;
        },
        populateSelectedPackage: function() {
            var cnt = "";
            var finalPayableAmount = 0;
            var packageCnt = 1;
            $(".packageBucketCnt:not(:first)").remove();
            $.each(this.selectedPackageList, function(key, value) {
                var bucketItem = $(".packageBucketCnt:first").clone();
                bucketItem.removeClass("hide");
                bucketItem
                    .find(".removePackage")
                    .data("packagecode", value.packageCode);
                bucketItem.find(".packageTypeCnt").text(value.packageTypeName);
                bucketItem.find(".packageNameCnt").text(value.packageName);
                bucketItem
                    .find(".packageTrainerCnt")
                    .text(value.packageTrainerName);
                bucketItem.find(".packageFinalPriceCnt").text(value.finalPrice);
                $(".packageBucketCnt:last").after(bucketItem);
                finalPayableAmount =
                    finalPayableAmount + parseInt(value.finalPrice);
                packageCnt++;
            });
            addMember.packagePaymentDetails.finalAmount = finalPayableAmount;
            $(".added-packs").removeClass("hide");
            $("#packageAsgnCnt").html(packageCnt);
            if (this.type !== "transferPackage") {
                this.memberData.finalPayableAmount = finalPayableAmount;
            }
            //$("#mb-bill-details-total").html(finalPayableAmount);
            $("#selectedPackages").html(cnt);
            $('[data-toggle="popover"]').popover();
            if (packageCnt == 1) {
                //$("#packageDetailsData").val("");
                this.showPackageInputs();
            } else {
                //$("#packageDetailsData").val(JSON.stringify(this.selectedPackageList));
            }
        },
        selectCouponCode: function(value, id) {
            this.memberData.appliedCouponDiscount = Number(
                value.couponDiscount
            ).toFixed(2);
            this.calculatePayable();
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        removeCoupon: function() {
            this.selectedItems.coupon = [];
            this.memberData.appliedCouponDiscount = 0;
            this.calculatePayable();
        },
        calculatePayable: function() {
            if (addMember.selectedItems.packageName.price === undefined) {
                return;
            }

            var calculatedMaxDiscount = Number(
                addMember.selectedItems.packageName.maxDiscountAllowed
            ).toFixed(2);
            var packagePayable = Number(
                addMember.selectedItems.packageName.price
            ).toFixed(2);
            if (addMember.memberData.appliedCouponDiscount !== undefined) {
                packagePayable = Number(
                    Number(addMember.selectedItems.packageName.price) -
                        Number(addMember.memberData.appliedCouponDiscount)
                ).toFixed(2);
                calculatedMaxDiscount = Number(
                    Number(
                        addMember.selectedItems.packageName.maxDiscountAllowed
                    ) - Number(addMember.memberData.appliedCouponDiscount)
                ).toFixed(2);
            }
            addMember.memberData.maxDiscountAvailable = calculatedMaxDiscount;
            addMember.memberData.packagePayableAmount = packagePayable;

            if (
                addMember.memberData.extraDiscount === undefined ||
                !addMember.memberData.extraDiscount
            ) {
                addMember.memberData.extraDiscount = "";
                addMember.memberData.packagePayableAmount = packagePayable;
                return;
            } else {
                addMember.memberData.extraDiscount = Number(
                    addMember.memberData.extraDiscount
                );
            }

            var errorMsgInvalidPrice = {
                number: true,
                max: Number(calculatedMaxDiscount),
                messages: {
                    max:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Discount limit exceeded",
                    number:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Invalid discount",
                },
            };
            var isValid = validate.formIsValid("addMemberForm", true);
            $("#packageDiscountAmount").rules("add", errorMsgInvalidPrice);
            var payableisValid = $("#packageDiscountAmount").valid();
            if (!payableisValid) {
                addMember.memberData.packagePayableAmount = packagePayable;
                return;
            }

            var diff = (
                packagePayable - Number(addMember.memberData.extraDiscount)
            ).toFixed(2);
            if (diff >= 0) {
                addMember.memberData.packagePayableAmount = diff;
            } else {
                addMember.memberData.packagePayableAmount = packagePayable;
            }
        },
        selectPaymentMode: function(value, id) {
            var isAdmin = $("#addMember").data("isAdmin");
            console.log(isAdmin);
            this.memberData.paymentMode = value.id;
            if (this.memberData.paymentMode !== "paymentlink") {
                this.memberData.paymentReferenceNumber = "";
                $("#paymentReferenceNumber-error").hide();
            }
            setTimeout(function() {
                $(".addMemberDatepickerApp").datetimepicker({
                    format: "d/m/Y",
                    timepicker: false,
                    scrollInput: false,
                    minDate: isAdmin ? false : 0,
                    maxDate: isAdmin ? false : 0,
                    onChangeDateTime: function(dp, $input) {
                        var inputModel = $input.data("model");
                        addMember.memberData[inputModel] = $input.val();
                    },
                });
                validate.customValidateMultiSelect([id]);
                $(".addMemberDatepickerApp").each(function() {
                    if ($(this).val() != "") {
                        addMember.memberData[$(this).data("model")] = $(
                            this
                        ).val();
                    }
                });
            }, 100);
        },
        selectTransferFeePaymentMode: function(value, id) {
            this.transfer.mode = value.id;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        maxLengthCheck: function(object) {
            if (object.value.length > object.maxLength)
                object.value = object.value.slice(0, object.maxLength);
        },
        validatePayableinInstalments: function() {
            var packagePayable = 0;
            var errorMsgInvalidPrice = {
                required: true,
                number: true,
                min: 1,
                max: Number(this.memberData.finalPayableAmount) - 1,
                messages: {
                    required:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Payable amount required",
                    min:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Payment should be greater than 0",
                    max:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Payment should be less than total price",
                    number:
                        "<i class='fa fa-info-circle' aria-hidden='true'></i> Invalid payable amount",
                },
            };
            $("#packageInstalmentAmount").rules("add", errorMsgInvalidPrice);
            var payableisValid = $("#packageInstalmentAmount").valid();
            if (!payableisValid) {
                addMember.memberData.paymentDueAmount = this.memberData.finalPayableAmount;
            } else {
                packagePayable = Number(
                    addMember.memberData.paymentPaidAmount
                ).toFixed(2);
                var diff =
                    Number(addMember.memberData.finalPayableAmount).toFixed(2) -
                    packagePayable;
                addMember.memberData.paymentPaidAmount = Number(
                    addMember.memberData.paymentPaidAmount
                );
                addMember.memberData.paymentDueAmount = diff;
            }
            return payableisValid;
        },
        checkIfPaymentIdExists: function(paymentId) {
            var formData = {
                paymentId: paymentId,
            };
            return this.$http.post("/payment/id/verify", formData);
        },
        assignPackage: function() {
            if (this.type == "renewPackage") {
                this.addPackeToBucket();
            }
            var currTab = $("#guide-tabs li.active a").data("target");
            var isValid = validate.formIsValid("addMemberForm");

            this.memberData.paymentDueAmount = this.memberData.finalPayableAmount;

            var customValidateElements = $(
                "#addMember #" + currTab + " div.multiselect"
            ).map(function(i, element) {
                if (
                    $(element).data("optional") === undefined ||
                    $(element).data("optional") == false
                ) {
                    return $(element)
                        .find("input")
                        .attr("id");
                }
            });

            var otherCustomValidElements = $(
                "#addMember #" + currTab + " div.multiselect"
            ).map(function(i, element) {
                var elemId = $(element)
                    .prop("id")
                    .replace("-multiselect", "");
                if (
                    $(element).data("optional") === undefined ||
                    $(element).data("optional") == false
                ) {
                    if (customValidateElements.length > 0) {
                        if ($.inArray(elemId, customValidateElements) == -1) {
                            return elemId;
                        }
                    } else {
                        return elemId;
                    }
                }
            });
            var isPaymentValid = true;
            if (
                currTab == "tab4default" &&
                Object.keys(this.selectedPackageList).length > 0
            ) {
                var customValidate = true;
            } else if (
                currTab == "tab4default" &&
                Object.keys(this.selectedPackageList).length == 0
            ) {
                validate.customValidateMultiSelect(customValidateElements);
                toastr["error"]("Please save the package details");
                return false;
            } else {
                var isPaymentValid = this.partial
                    ? this.validatePayableinInstalments()
                    : true;
                var customValidate = validate.customValidateMultiSelect(
                    customValidateElements
                );
            }

            if (!(isValid && customValidate && isPaymentValid)) {
                return false;
            }
            var tabForm = require("../tabForm");
            var autoForward = tabForm.autoForward(memberFormTabsSettings, 1);
            if (autoForward.status) {
                var activeTabId = $("div#addMember")
                    .find(".tab-content > .active")
                    .attr("id");
                if (activeTabId === "tab6default") {
                    if (!this.partial) {
                        this.memberData.paymentDueAmount = 0;
                        this.memberData.paymentPaidAmount = this.memberData.finalPayableAmount;
                    }
                    var copyObj = JSON.parse(JSON.stringify(this.memberData));
                    copyObj.userCode = this.memberData.userCode;
                    copyObj.selectedPackageList = JSON.stringify(
                        this.selectedPackageList
                    );
                    copyObj.packagePaymentDetails = JSON.stringify(
                        this.packagePaymentDetails
                    );
                    copyObj.partial = this.partial;
                    copyObj.cgst = this.cgst;
                    copyObj.sgst = this.sgst;
                    copyObj.paymentNote = this.paymentNote;
                    copyObj.sendTNC = this.sendTNC;
                    copyObj.salesRepresentativeCode =
                        addMember.selectedSalesRep.code || null;
                    this.showBtnLoading = true;
                    $("#addMemberPrevTabBtn").attr("disabled", "disabled");
                    if (this.memberData.paymentMode === "paymentlink") {
                        this.checkIfPaymentIdExists(
                            this.memberData.paymentReferenceNumber
                        ).then((response) => {
                            if (!response.body.result) {
                                toastr["error"](
                                    "Please enter valid Payment Reference Number"
                                );
                                return;
                            }
                            this.sendAjaxToAssignPackage(copyObj);
                        });
                    } else {
                        this.sendAjaxToAssignPackage(copyObj);
                    }
                }
            }
        },
        sendAjaxToAssignPackage: function(copyObj) {
            var memberAssignPackLoader = Ladda.create(
                document.querySelector(".memberBtnAssignPackLoader")
            );
            memberAssignPackLoader.start();
            this.$http.post("/member/assignPackage", copyObj).then(
                (response) => {
                    if (response.data.hasError) {
                        toastr["error"](response.data.message);
                        memberAssignPackLoader.stop();
                        memberAssignPackLoader.remove();
                        this.showBtnLoading = false;
                        $("#addMemberPrevTabBtn").removeAttr(
                            "disabled",
                            "disabled"
                        );
                        return false;
                    }
                    toastr["success"](response.data.message);
                    memberAssignPackLoader.stop();
                    memberAssignPackLoader.remove();
                    this.showBtnLoading = false;
                    $("#addMemberPrevTabBtn").removeAttr(
                        "disabled",
                        "disabled"
                    );
                    $("#addMember").modal("hide");

                    this.selectedPackageList = {};
                    addMember.resetAddMemberForm();
                    if (typeof appMemberDetails !== "undefined") {
                        if (
                            Number(
                                appMemberDetails.memberDetailsData
                                    .memberIsActive
                            ) == 0
                        ) {
                            appMemberDetails.getMemberDetails();
                        } else if (viewPackages) {
                            appMemberDetails.getMemberPackageDetails();
                            appMemberDetails.getFreezingHistory();
                        }
                    }
                },
                (response) => {
                    memberAssignPackLoader.stop();
                    memberAssignPackLoader.remove();
                    this.showBtnLoading = false;
                    $("#addMemberPrevTabBtn").removeAttr(
                        "disabled",
                        "disabled"
                    );
                    toastr["error"]("Something went wrong!", "FAILED!");
                    this.selectedPackageList = {};
                }
            );
        },
        addMember: function() {
            var currTab = $("#guide-tabs li.active a").data("target");
            var isValid = validate.formIsValid("addMemberForm", true);
            var emailValidation = $("#memEmail").valid();
            var mobileValidation = $("#memMobile").valid();
            if (!emailValidation || !mobileValidation) {
                $("#mem-email-mobile-err").empty();
                if ($("#memEmail-error").length) {
                    $("#mem-email-mobile-err").html(
                        $("#memEmail-error").html()
                    );
                    $("#memEmail-error").remove();
                }
                if ($("#memMobile-error").length) {
                    $("#mem-email-mobile-err").html(
                        $("#memMobile-error").html()
                    );
                    $("#memMobile-error").remove();
                }
            } else {
                $("#mem-email-mobile-err").empty();
            }
            var customValidateElements = $(
                "#addMember #" + currTab + " div.multiselect"
            ).map(function(i, element) {
                if (
                    $(element).data("optional") === undefined ||
                    $(element).data("optional") == false
                ) {
                    return $(element)
                        .find("input")
                        .attr("id");
                }
            });
            var otherCustomValidElements = $(
                "#addMember #" + currTab + " div.multiselect"
            ).map(function(i, element) {
                var elemId = $(element)
                    .prop("id")
                    .replace("-multiselect", "");
                if (
                    $(element).data("optional") === undefined ||
                    $(element).data("optional") == false
                ) {
                    if (customValidateElements.length > 0) {
                        if ($.inArray(elemId, customValidateElements) == -1) {
                            return elemId;
                        }
                    } else {
                        return elemId;
                    }
                }
            });
            var isPaymentValid = true;
            if (
                currTab == "tab4default" &&
                Object.keys(this.selectedPackageList).length > 0
            ) {
                var customValidate = true;
            } else if (
                currTab == "tab4default" &&
                Object.keys(this.selectedPackageList).length == 0
            ) {
                validate.customValidateMultiSelect(customValidateElements);
                toastr["error"]("Please save the package details");
                return false;
            } else {
                var isPaymentValid = this.partial
                    ? this.validatePayableinInstalments()
                    : true;
                var customValidate = validate.customValidateMultiSelect(
                    customValidateElements
                );
            }

            if (
                !(
                    isValid &&
                    customValidate &&
                    this.memberVerificationError == "" &&
                    isPaymentValid
                )
            ) {
                return false;
            }
            var tabForm = require("../tabForm");
            var autoForward = tabForm.autoForward(memberFormTabsSettings, 1);
            if (autoForward.status) {
                if (!this.partial) {
                    this.memberData.paymentDueAmount = 0;
                    this.memberData.paymentPaidAmount = this.memberData.finalPayableAmount;
                }
                var activeTabId = $("div#addMember")
                    .find(".tab-content > .active")
                    .attr("id");
                $("#addMemberPrevTabBtn").removeClass("hidden");
                if (activeTabId === "tab6default") {
                    //this.getPaymentDetails();
                    addMember.memberData.mobile =
                        addMember.memberData.user.mobile;
                    addMember.memberData.callingCode =
                        addMember.country.callingCode;
                    addMember.memberData.email =
                        addMember.memberData.user.email;
                    var copyObj = JSON.parse(JSON.stringify(this.memberData));
                    copyObj.selectedPackageList = JSON.stringify(
                        this.selectedPackageList
                    );
                    copyObj.partial = this.partial;
                    copyObj.sendTNC = this.sendTNC;
                    copyObj.sendLiability = this.sendLiability;
                    copyObj.cgst = this.cgst;
                    copyObj.sgst = this.sgst;
                    copyObj.paymentNote = this.paymentNote;
                    copyObj.emergency = this.emergency;
                    copyObj.callingCodeEmergencyContact = this.emergencyCallingCode.callingCode;
                    copyObj.salesRepresentativeCode =
                        addMember.selectedSalesRep.code || null;
                    this.showBtnLoading = true;
                    $("#addMemberPrevTabBtn").attr("disabled", "disabled");
                    if (this.memberData.paymentMode === "paymentlink") {
                        this.checkIfPaymentIdExists(
                            addMember.memberData.paymentReferenceNumber
                        ).then((response) => {
                            if (!response.body.result) {
                                toastr["error"](
                                    "Please enter valid Payment Reference Number"
                                );
                                return;
                            }
                            this.sendAjaxToAddMember(copyObj);
                        });
                    } else {
                        this.sendAjaxToAddMember(copyObj);
                    }
                } else {
                    $(".nav-pills > .active")
                        .next("li")
                        .find("a")
                        .trigger("click");
                }
            }
        },
        sendAjaxToAddMember: function(copyObj) {
            var memberAddLoader = Ladda.create(
                document.querySelector(".memberBtnAddLoader")
            );
            memberAddLoader.start();
            this.$http.post("/member/add", copyObj).then(
                (response) => {
                    if (response.data.hasError) {
                        toastr["error"](response.body.message);
                        memberAddLoader.stop();
                        memberAddLoader.remove();
                        this.showBtnLoading = false;
                        $("#addMemberPrevTabBtn").removeAttr(
                            "disabled",
                            "disabled"
                        );
                        return false;
                    }
                    toastr["success"](response.body.message);
                    (this.memberData = {
                        leadCode: "",
                        user: {
                            email: "",
                            mobile: "",
                            code: "",
                        },
                        dateOfPayment: moment().format("DD/MM/YYYY"),
                        activationDate: moment().format("DD/MM/YYYY"),
                    }),
                        (this.errorMessage = "");
                    $("#addMember").modal("hide");
                    memberAddLoader.stop();
                    memberAddLoader.remove();
                    this.showBtnLoading = false;
                    $("#addMemberPrevTabBtn").removeAttr(
                        "disabled",
                        "disabled"
                    );
                    if (response.data.result.code !== undefined) {
                        window.location.href =
                            "/member/" + response.data.result.code;
                    } else if (typeof appMembers !== "undefined") {
                        appMembers.getVueItems(1);
                    } else {
                        window.location.href = "/members";
                    }
                    this.selectedPackageList = {};
                },
                (response) => {
                    toastr["error"]("Something went wrong!", "FAILED!");
                    memberAddLoader.stop();
                    memberAddLoader.remove();
                    this.showBtnLoading = false;
                    $("#addMemberPrevTabBtn").removeAttr(
                        "disabled",
                        "disabled"
                    );
                    this.selectedPackageList = {};
                }
            );
        },
        getAllPackageTypeList: function() {
            this.$http.get("/package/type/list").then((response) => {
                this.allPackageTypeList = response.data.result;
                if (
                    (this.packageEditType || this.type == "renewPackage") &&
                    this.memberData.packageTypeName !== undefined
                ) {
                    this.selectedItems.packageType = $.map(
                        this.allPackageTypeList,
                        function(value, index) {
                            if (
                                value.name ==
                                addMember.memberData.packageTypeName
                            ) {
                                return value;
                            }
                        }
                    );
                    if (Object.keys(this.selectedItems.packageType).length) {
                        this.selectedItems.packageType = this.selectedItems.packageType[0];
                        this.memberData.packageType = this.selectedItems.packageType.name;
                        addMember.getAllPackageList();
                    }
                }
            });
        },
        getAllPackageList: function() {
            this.allPackageList = [];
            this.$http
                .get("/package/list", {
                    params: {
                        searchPackageType: this.memberData.packageType,
                        pagination: 0,
                        isValidPackages: 1,
                    },
                })
                .then((response) => {
                    this.allPackageList = [];
                    allPackageListResult = response.data.result;
                    $.each(allPackageListResult, function(index, item) {
                        if (item.type === "Personal Training") {
                            item.label = `${
                                item.name
                            } - ${Vue.options.filters.convertCurrency(
                                item.price
                            )} · ${item.duration} ${item.durationUnit} (${
                                item.noOfSessions
                            } Sessions)`;
                        } else {
                            item.label =
                                item.name +
                                " - " +
                                Vue.options.filters.convertCurrency(
                                    item.price
                                ) +
                                " · " +
                                item.duration +
                                " " +
                                item.durationUnit;
                        }
                        addMember.allPackageList.push(item);
                    });
                    if (
                        (this.packageEditType ||
                            this.type == "renewPackage" ||
                            this.type == "transferPackage") &&
                        this.memberData.packageCode !== undefined
                    ) {
                        this.selectedItems.packageName = $.map(
                            this.allPackageList,
                            function(value, index) {
                                if (
                                    value.code.toLowerCase() ==
                                    addMember.memberData.packageCode.toLowerCase()
                                ) {
                                    return value;
                                }
                            }
                        );
                        if (
                            Object.keys(this.selectedItems.packageName).length
                        ) {
                            this.selectedItems.packageName = this.selectedItems.packageName[0];
                            this.memberData.packagePayableAmount = this.memberData.packagePrice = this.selectedItems.packageName.price;
                            this.memberData.packageMaxDiscount = this.selectedItems.packageName.maxDiscountAllowed;
                            this.memberData.maxDiscountType = this.selectedItems.packageName.maxDiscountType;
                            this.memberData.maxDiscountAvailable = this.selectedItems.packageName.maxDiscountAllowed;
                            addMember.getPackageCoupon();
                        }
                    }
                });
        },
        getAllTrainerList: function() {
            this.$http.get("/trainer/list").then((response) => {
                this.allPackageTrainerList = response.data.result;
                if (
                    (this.packageEditType ||
                        this.type == "renewPackage" ||
                        this.type == "transferPackage") &&
                    this.memberData.trainerCode !== undefined
                ) {
                    this.selectedItems.packageTrainer = $.map(
                        this.allPackageTrainerList,
                        function(value, index) {
                            if (
                                value.code == addMember.memberData.trainerCode
                            ) {
                                return value;
                            }
                        }
                    );
                    if (Object.keys(this.selectedItems.packageTrainer).length) {
                        this.selectedItems.packageTrainer = this.selectedItems.packageTrainer[0];
                    }
                }
            });
        },
        resetAddMemberForm: function() {
            $("#addMemberForm")[0].reset();
            setTimeout(function() {
                $("#addMember label.error").hide();
                $("#sameadd").prop("checked", false);
            }, 1);
            (addMember.memberData = {
                leadCode: "",
                user: {
                    email: "",
                    mobile: "",
                    code: "",
                },
                dateOfPayment: moment().format("DD/MM/YYYY"),
                activationDate: moment().format("DD/MM/YYYY"),
                dob: "",
                paymentDueAmount: 0,
            }),
                (addMember.selectedItems.gender = []);
            $("#memberdob").val("");
            addMember.partial = false;
            addMember.sendTNC = false;
            addMember.sendLiability = false;
            addMember.paymentNote = "";
            addMember.transfer = {
                payTransferFee: false,
                amount: "",
                editGst: false,
                reference: "",
                date: "",
                cgst: 9,
                sgst: 9,
            };
            addMember.selectedItems.packageType = [];
            addMember.selectedItems.packageName = [];
            addMember.selectedItems.packageTrainer = [];
            addMember.selectedSalesRep = [];
            addMember.selectedItems.transfer.paymentMode = [];
            addMember.selectedPackageList = {};
            addMember.populateSelectedPackage();
        },
        getPackageCoupon: function() {
            this.$http
                .get("/coupon/package/get", {
                    params: {
                        packageCode: this.memberData.packageCode,
                    },
                })
                .then((response) => {
                    this.couponList = [];
                    this.couponList = response.data.result.map((coupon) => {
                        return {
                            ...coupon,
                            label: `${coupon.name} - ${
                                coupon.discountType === "Flat"
                                    ? coupon.discountType
                                    : ""
                            } ${
                                coupon.discountType === "Flat"
                                    ? Vue.options.filters.convertCurrency(
                                          coupon.discountValue
                                      )
                                    : coupon.discountValue + "%"
                            } off on above ${Vue.options.filters.convertCurrency(
                                coupon.minimumAmount
                            )}`,
                        };
                    });
                    if (
                        this.memberData.couponCode !== undefined &&
                        this.memberData.couponCode
                    ) {
                        this.selectedItems.coupon = $.map(
                            this.couponList,
                            function(value, index) {
                                if (
                                    value.code ==
                                    addMember.memberData.couponCode
                                ) {
                                    return value;
                                }
                            }
                        );
                        if (Object.keys(this.selectedItems.coupon).length) {
                            this.selectedItems.coupon = this.selectedItems.coupon[0];
                            this.memberData.appliedCouponDiscount = this.selectedItems.coupon.couponDiscount;
                        }
                    }
                    this.calculatePayable();
                });
        },
        openPackageEditForm: function(packageDetails) {
            this.packageEditType = true;
            this.memberData.packageTypeName = packageDetails.packageTypeName;
            this.memberData.packageName = packageDetails.packageName;
            this.memberData.packageCode = this.memberData.prevMemberPackageCode =
                packageDetails.packageCode;
            this.memberData.trainerCode = packageDetails.trainerCode;
            this.memberData.extraDiscount = packageDetails.additionalDiscount;
            this.memberData.couponCode = packageDetails.couponCode;
            this.memberData.appliedCouponDiscount =
                packageDetails.couponDiscount;
            this.memberData.packagePayableAmount = packageDetails.finalPrice;
            this.memberData.activationDate = packageDetails.activationDate;
            $("input[name=activationDate]").datetimepicker("setOptions", {
                value: moment(
                    packageDetails.activationDate,
                    "DD/MM/YYYY"
                ).toDate(),
            });
            $("#selectPackageBox").slideDown("slow");
            $("#addMorePackage").addClass("hide");
            var packageCount = $("#packageAsgnCnt").text();
            if (packageCount > 1) {
                $(".mbPkgActivityClose").removeClass("hide");
            } else {
                if (!$(".mbPkgActivityClose").hasClass("hide")) {
                    $(".mbPkgActivityClose").addClass("hide");
                }
            }
            $("#addMember label.error").hide();
            this.getAllPackageTypeList();
            this.getAllTrainerList();
        },
        deletePackage: function(packageCode) {
            Vue.delete(this.selectedPackageList, packageCode);
            this.populateSelectedPackage();
        },
        checkCenterLiability: function() {
            this.$http.get("/center/hasliability").then((response) => {
                this.centerLiabilityAvailable = response.data.result;
            });
        },
        checkCenterTnc: function() {
            this.$http.get("/center/hastnc").then((response) => {
                this.centerTncAvailable = response.data.result;
            });
        },
        transferPackage: function() {
            var currTab = $("#guide-tabs li.active a").data("target");
            var isValid = validate.formIsValid("addMemberForm", true);
            var emailValidation = $("#memEmail").valid();
            var mobileValidation = $("#memMobile").valid();
            if (!emailValidation || !mobileValidation) {
                $("#mem-email-mobile-err").empty();
                if ($("#memEmail-error").length) {
                    $("#mem-email-mobile-err").html(
                        $("#memEmail-error").html()
                    );
                    $("#memEmail-error").remove();
                }
                if ($("#memMobile-error").length) {
                    $("#mem-email-mobile-err").html(
                        $("#memMobile-error").html()
                    );
                    $("#memMobile-error").remove();
                }
            } else {
                $("#mem-email-mobile-err").empty();
            }
            var customValidateElements = $(
                "#addMember #" + currTab + " div.multiselect"
            ).map(function(i, element) {
                if (
                    $(element).data("optional") === undefined ||
                    $(element).data("optional") == false
                ) {
                    return $(element)
                        .find("input")
                        .attr("id");
                }
            });
            var otherCustomValidElements = $(
                "#addMember #" + currTab + " div.multiselect"
            ).map(function(i, element) {
                var elemId = $(element)
                    .prop("id")
                    .replace("-multiselect", "");
                if (
                    $(element).data("optional") === undefined ||
                    $(element).data("optional") == false
                ) {
                    if (customValidateElements.length > 0) {
                        if ($.inArray(elemId, customValidateElements) == -1) {
                            return elemId;
                        }
                    } else {
                        return elemId;
                    }
                }
            });
            var isPaymentValid = true;
            if (
                currTab == "tab4default" &&
                Object.keys(this.selectedPackageList).length > 0
            ) {
                var customValidate = true;
            } else if (
                currTab == "tab4default" &&
                Object.keys(this.selectedPackageList).length == 0
            ) {
                validate.customValidateMultiSelect(customValidateElements);
                toastr["error"]("Please save the package details");
                return false;
            } else {
                var isPaymentValid = this.partial
                    ? this.validatePayableinInstalments()
                    : true;
                var customValidate = validate.customValidateMultiSelect(
                    customValidateElements
                );
            }

            if (
                !(
                    isValid &&
                    customValidate &&
                    this.memberVerificationError == "" &&
                    isPaymentValid
                )
            ) {
                return false;
            }

            var tabForm = require("../tabForm");
            var autoForward = tabForm.autoForward(memberFormTabsSettings, 1);
            if (autoForward.status) {
                if (!this.partial) {
                    this.memberData.paymentDueAmount = 0;
                    this.memberData.paymentPaidAmount = this.memberData.finalPayableAmount;
                }
                var memberAddLoader = Ladda.create(
                    document.querySelector(".memberBtnAssignPackLoader")
                );
                var activeTabId = $("div#addMember")
                    .find(".tab-content > .active")
                    .attr("id");
                $("#addMemberPrevTabBtn").removeClass("hidden");
                if (activeTabId === "tab6default") {
                    //this.getPaymentDetails();
                    addMember.memberData.mobile =
                        addMember.memberData.user.mobile;
                    addMember.memberData.callingCode =
                        addMember.country.callingCode;
                    addMember.memberData.email =
                        addMember.memberData.user.email;
                    addMember.memberData.code = addMember.memberData.user.code;
                    var copyObj = JSON.parse(JSON.stringify(this.memberData));
                    copyObj.selectedPackageList = JSON.stringify(
                        this.selectedPackageList
                    );
                    addMember.transfer.date =
                        addMember.memberData.transferPaymentDate;
                    copyObj.transferFeeDetails = addMember.transfer;
                    copyObj.partial = this.partial;
                    copyObj.sendTNC = this.sendTNC;
                    copyObj.sendLiability = this.sendLiability;
                    copyObj.cgst = this.cgst;
                    copyObj.sgst = this.sgst;
                    copyObj.paymentNote = this.paymentNote;
                    copyObj.emergency = this.emergency;
                    copyObj.callingCodeEmergencyContact = this.emergencyCallingCode.callingCode;
                    copyObj.salesRepresentativeCode =
                        addMember.selectedSalesRep.code || null;
                    memberAddLoader.start();
                    this.showBtnLoading = true;
                    $("#addMemberPrevTabBtn").attr("disabled", "disabled");
                    console.log(copyObj);
                    this.$http
                        .post(
                            "/member/package/transfer/" +
                                appMemberDetails.memberCode,
                            copyObj
                        )
                        .then(
                            (response) => {
                                if (response.data.hasError) {
                                    toastr["error"](response.body.message);
                                    memberAddLoader.stop();
                                    memberAddLoader.remove();
                                    this.showBtnLoading = false;
                                    $("#addMemberPrevTabBtn").removeAttr(
                                        "disabled",
                                        "disabled"
                                    );
                                    return false;
                                }
                                toastr["success"](response.body.message);
                                (this.memberData = {
                                    leadCode: "",
                                    user: {
                                        email: "",
                                        mobile: "",
                                        code: "",
                                    },
                                    dateOfPayment: moment().format(
                                        "DD/MM/YYYY"
                                    ),
                                    activationDate: moment().format(
                                        "DD/MM/YYYY"
                                    ),
                                }),
                                    (this.errorMessage = "");
                                $("#addMember").modal("hide");
                                memberAddLoader.stop();
                                memberAddLoader.remove();
                                this.showBtnLoading = false;
                                $("#addMemberPrevTabBtn").removeAttr(
                                    "disabled",
                                    "disabled"
                                );
                                appMemberDetails.getMemberDetails(1);
                                this.selectedPackageList = {};
                            },
                            (response) => {
                                toastr["error"](
                                    "Something went wrong!",
                                    "FAILED!"
                                );
                                memberAddLoader.stop();
                                memberAddLoader.remove();
                                this.showBtnLoading = false;
                                $("#addMemberPrevTabBtn").removeAttr(
                                    "disabled",
                                    "disabled"
                                );
                                this.selectedPackageList = {};
                            }
                        );
                } else {
                    $(".nav-pills > .active")
                        .next("li")
                        .find("a")
                        .trigger("click");
                }
            } else {
                $(".nav-pills > .active")
                    .next("li")
                    .find("a")
                    .trigger("click");
            }
        },
        getUpgradeToPackageList: function(userPackageCode) {
            this.allPackageList = [];
            this.$http
                .get("/package/list", {
                    params: {
                        pagination: 0,
                        isValidPackages: 1,
                        isForUpgrade: 1,
                        userPackageCode: userPackageCode,
                    },
                })
                .then((response) => {
                    this.allPackageList = [];
                    allPackageListResult = response.data.result;
                    $.each(allPackageListResult, function(index, item) {
                        if (item.type === "Personal Training") {
                            item.label = `${
                                item.name
                            } - ${Vue.options.filters.convertCurrency(
                                item.price
                            )} · ${item.duration} ${item.durationUnit} (${
                                item.noOfSessions
                            } Sessions)`;
                        } else {
                            item.label =
                                item.name +
                                " - " +
                                Vue.options.filters.convertCurrency(
                                    item.price
                                ) +
                                " · " +
                                item.duration +
                                " " +
                                item.durationUnit;
                        }
                        addMember.allPackageList.push(item);
                    });
                    if (
                        (this.packageEditType ||
                            this.type == "upgradePackage") &&
                        this.memberData.packageCode !== undefined
                    ) {
                        this.selectedItems.packageName = $.map(
                            this.allPackageList,
                            function(value, index) {
                                if (
                                    value.code.toLowerCase() ==
                                    addMember.memberData.packageCode.toLowerCase()
                                ) {
                                    return value;
                                }
                            }
                        );
                        if (
                            Object.keys(this.selectedItems.packageName).length
                        ) {
                            this.selectedItems.packageName = this.selectedItems.packageName[0];
                            this.memberData.packagePayableAmount = this.memberData.packagePrice = this.selectedItems.packageName.price;
                            this.memberData.packageMaxDiscount = this.selectedItems.packageName.maxDiscountAllowed;
                            this.memberData.maxDiscountType = this.selectedItems.packageName.maxDiscountType;
                            this.memberData.maxDiscountAvailable = this.selectedItems.packageName.maxDiscountAllowed;
                            addMember.getPackageCoupon();
                        }
                    }
                });
        },
        upgradePackage: function() {
            if (
                addMember.memberData.extraDiscount !== "" &&
                addMember.memberData.extraDiscount !== null &&
                addMember.memberData.extraDiscount !== undefined &&
                !isNaN(addMember.memberData.extraDiscount)
            ) {
                addMember.upgradePackgeInfo.currentPayableAmount =
                    Number(this.selectedItems.packageName.price) -
                    parseInt(addMember.memberData.extraDiscount) -
                    parseInt(addMember.memberData.appliedCouponDiscount);
            } else {
                addMember.upgradePackgeInfo.currentPayableAmount =
                    Number(this.selectedItems.packageName.price) -
                    parseInt(addMember.memberData.appliedCouponDiscount);
            }
            this.upgradePackgeInfo.balanceAmount =
                this.upgradePackgeInfo.currentPayableAmount -
                this.upgradePackgeInfo.paidAmount;
            this.memberData.finalPayableAmount = this.upgradePackgeInfo.balanceAmount;
            var currTab = $("#guide-tabs li.active a").data("target");
            var isValid = validate.formIsValid("addMemberForm", true);
            var customValidateElements = $(
                "#addMember #" + currTab + " div.multiselect"
            ).map(function(i, element) {
                if (
                    $(element).data("optional") === undefined ||
                    $(element).data("optional") == false
                ) {
                    return $(element)
                        .find("input")
                        .attr("id");
                }
            });
            var otherCustomValidElements = $(
                "#addMember #" + currTab + " div.multiselect"
            ).map(function(i, element) {
                var elemId = $(element)
                    .prop("id")
                    .replace("-multiselect", "");
                if (
                    $(element).data("optional") === undefined ||
                    $(element).data("optional") == false
                ) {
                    if (customValidateElements.length > 0) {
                        if ($.inArray(elemId, customValidateElements) == -1) {
                            return elemId;
                        }
                    } else {
                        return elemId;
                    }
                }
            });
            var customValidate = validate.customValidateMultiSelect(
                customValidateElements
            );
            if (!(isValid && customValidate)) {
                return false;
            }

            var tabForm = require("../tabForm");
            var autoForward = tabForm.autoForward(memberFormTabsSettings, 1);

            if (autoForward.status) {
                var memberAddLoader = Ladda.create(
                    document.querySelector(".memberBtnAssignPackLoader")
                );
                var activeTabId = $("div#addMember")
                    .find(".tab-content > .active")
                    .attr("id");
                $("#addMemberPrevTabBtn").removeClass("hidden");
                if (activeTabId === "tab6default") {
                    this.addPackeToBucket();
                    if (!this.partial) {
                        this.memberData.paymentDueAmount = 0;
                        this.memberData.paymentPaidAmount =
                            addMember.upgradePackgeInfo.balanceAmount;
                    }
                    addMember.memberData.mobile =
                        addMember.memberData.user.mobile;
                    addMember.memberData.email =
                        addMember.memberData.user.email;
                    addMember.memberData.code = addMember.memberData.user.code;
                    var copyObj = JSON.parse(JSON.stringify(this.memberData));
                    copyObj.selectedPackageList = JSON.stringify(
                        this.selectedPackageList
                    );
                    copyObj.packagePayableAmount =
                        addMember.upgradePackgeInfo.balanceAmount;
                    copyObj.salesRepresentativeCode =
                        addMember.selectedSalesRep.code || null;
                    copyObj.partial = this.partial;
                    copyObj.sendTNC = this.sendTNC;
                    copyObj.sendLiability = this.sendLiability;
                    copyObj.cgst = this.cgst;
                    copyObj.sgst = this.sgst;
                    copyObj.paymentNote = this.paymentNote;
                    memberAddLoader.start();
                    this.showBtnLoading = true;
                    $("#addMemberPrevTabBtn").attr("disabled", "disabled");
                    this.$http
                        .post(
                            "/member/package/upgrade/" +
                                addMember.upgradePackgeInfo.userPackageCode,
                            copyObj
                        )
                        .then(
                            (response) => {
                                if (response.data.hasError) {
                                    toastr["error"](response.body.message);
                                    memberAddLoader.stop();
                                    memberAddLoader.remove();
                                    this.showBtnLoading = false;
                                    $("#addMemberPrevTabBtn").removeAttr(
                                        "disabled",
                                        "disabled"
                                    );
                                    return false;
                                }
                                toastr["success"](response.body.message);
                                (this.memberData = {
                                    leadCode: "",
                                    user: {
                                        email: "",
                                        mobile: "",
                                        code: "",
                                    },
                                    dateOfPayment: moment().format(
                                        "DD/MM/YYYY"
                                    ),
                                    activationDate: moment().format(
                                        "DD/MM/YYYY"
                                    ),
                                }),
                                    (this.errorMessage = "");
                                $("#addMember").modal("hide");
                                memberAddLoader.stop();
                                memberAddLoader.remove();
                                this.showBtnLoading = false;
                                $("#addMemberPrevTabBtn").removeAttr(
                                    "disabled",
                                    "disabled"
                                );
                                appMemberDetails.getMemberDetails(1);
                                this.selectedPackageList = {};
                            },
                            (response) => {
                                toastr["error"](
                                    "Something went wrong!",
                                    "FAILED!"
                                );
                                memberAddLoader.stop();
                                memberAddLoader.remove();
                                this.showBtnLoading = false;
                                $("#addMemberPrevTabBtn").removeAttr(
                                    "disabled",
                                    "disabled"
                                );
                                this.selectedPackageList = {};
                            }
                        );
                } else {
                    $(".nav-pills > .active")
                        .next("li")
                        .find("a")
                        .trigger("click");
                }
            } else {
                $(".nav-pills > .active")
                    .next("li")
                    .find("a")
                    .trigger("click");
            }
        },
    },
});

Vue.mixin({
    methods: {
        convertToMember: function(leadData, type = null) {
            var lead, leadCode;
            $("#leadSearch").modal("hide");
            $(".hideOnLeads").hide();
            $("#addMemberForm")[0].reset();
            addMember.memberVerificationError = "";
            validate.resetFormValidationErrors("addMemberForm");
            $("#addMemberForm")
                .find("input")
                .not(".gstPercentage")
                .prop("readonly", false);
            $("#addMemberForm")
                .find("select")
                .prop("disabled", false);
            lead = leadData;
            leadCode = leadData.leadCode;
            var tabForm = require("../tabForm");
            var argsReset = {
                tabUlIdName: "guide-tabs",
                formIdName: "addMemberForm",
                mainWrappersClassName: "formTabWrappers",
            };
            tabForm.setToFirstTab(argsReset);
            $("#mb-pkg-addedit").text("Proceed");
            $("form label.error").hide();
            memberFormTabsSettings.tabsCount = 3;
            (addMember.memberData = {
                leadCode: "",
                user: {
                    email: "",
                    mobile: "",
                    code: "",
                    callingCode: "",
                },
                dateOfPayment: moment().format("DD/MM/YYYY"),
                activationDate: moment().format("DD/MM/YYYY"),
                dob: "",
                paymentDueAmount: 0,
            }),
                (addMember.memberData.name = lead.leadUserName);

            if (lead.leadUserEmail) {
                addMember.memberData.user.email = addMember.memberData.email =
                    lead.leadUserEmail;
                // $("#memEmail").attr("readonly", true);
            }
            if (lead.leadUserMobile) {
                addMember.memberData.user.mobile = addMember.memberData.mobile =
                    lead.leadUserMobile;
                addMember.memberData.user.callingCode = lead.callingCode;
                addMember.country.callingCode = lead.callingCode;
                // $("#memMobile").attr("readonly", true);
            }
            if (lead.leadUserDob) {
                if (moment(lead.leadUserDob).isValid()) {
                    addMember.memberData.dob = moment(lead.leadUserDob).format(
                        "DD/MM/YYYY"
                    );
                }
            }
            addMember.memberData.gender = lead.leadUserGender;

            //single select
            addMember.selectedItems.gender = lead.leadUserGender
                ? addMember.genderList.find(
                      (o) => o.id === lead.leadUserGender.toLowerCase()
                  )
                : [];
            addMember.memberData.leadCode = leadCode;
            //addMember.memberData.leadSourceId = leadData.lead_source.id;
            addMember.headerMessage = "Add Member";
            addMember.type = "add";
            $(".autoCapitalize").keyup();
            addMember.validateMemberUser();
            $("#addMember").modal("show");
            $("#tabs .nav-pills a:first").tab("show");
        },
        memberAssignpackage: function(userCode) {
            var tabForm = require("../tabForm");
            var argsReset = {
                tabUlIdName: "guide-tabs",
                formIdName: "addMemberForm",
                mainWrappersClassName: "formTabWrappers",
            };
            addMember.resetAddMemberForm();
            tabForm.setToFirstTab(argsReset);
            $("#mb-pkg-addedit").text("Proceed");
            $("form label.error").hide();
            memberFormTabsSettings.tabsCount = 2;
            addMember.headerMessage = "Assign Package";
            addMember.type = "assignPackage";
            addMember.memberData.userCode = userCode;
            $("#addMember").modal("show");
            $("#tabs .nav-pills a:first").tab("show");
        },
        openMemberPackageTransfer: function(payableAmount, packageDetails) {
            var tabForm = require("../tabForm");
            var argsReset = {
                tabUlIdName: "guide-tabs",
                formIdName: "addMemberForm",
                mainWrappersClassName: "formTabWrappers",
            };
            tabForm.setToFirstTab(argsReset);
            addMember.resetAddMemberForm();
            $("#mb-pkg-addedit").text("Proceed");
            $("form label.error").hide();
            memberFormTabsSettings.tabsCount = 3;
            addMember.headerMessage = "Transfer Package";
            addMember.type = "transferPackage";
            addMember.memberData.finalPayableAmount = payableAmount;
            packageDetails.map(function(packageValue, key) {
                var obj = {
                    packageTypeName: packageValue.package.type,
                    packageName: packageValue.package.name,
                    packageCode: packageValue.package.code,
                    trainerCode: packageValue.package.trainer.code,
                    packagePrice: packageValue.package.price,
                    finalPrice: packageValue.package.price,
                    packageTrainerName: "",
                    activationDate: moment().format("DD/MM/YYYY"),
                    couponCode: "",
                    couponDiscount: 0,
                    additionalDiscount: 0,
                };
                Vue.set(
                    addMember.selectedPackageList,
                    packageValue.package.code +
                        "_" +
                        Object.keys(addMember.selectedPackageList).length,
                    obj
                );
            });
            $("#selectPackageBox").hide();
            $("#tabs .nav-pills a:first").tab("show");
            $("#addMember").modal("show");
        },
        renewMemberPackage: function(
            userPackageCode,
            packageTypeName,
            packageCode,
            memberCode,
            expiryDate,
            trainerCode
        ) {
            var tabForm = require("../tabForm");
            var argsReset = {
                tabUlIdName: "guide-tabs",
                formIdName: "addMemberForm",
                mainWrappersClassName: "formTabWrappers",
            };
            addMember.resetAddMemberForm();
            tabForm.setToFirstTab(argsReset);
            $("#mb-pkg-addedit").text("Proceed");
            $("form label.error").hide();
            memberFormTabsSettings.tabsCount = 2;
            addMember.headerMessage = "Renew Package";
            addMember.type = "renewPackage";
            addMember.memberData.userCode = memberCode;
            addMember.memberData.packageTypeName = packageTypeName;
            addMember.memberData.packageCode = packageCode;
            addMember.memberData.renewedFromUserPackageCode = userPackageCode;
            addMember.memberData.trainerCode = trainerCode;
            if (moment().diff(expiryDate, "days") < 0) {
                addMember.memberData.activationDate = moment(expiryDate)
                    .add(1, "days")
                    .format("DD/MM/YYYY");
            } else {
                addMember.memberData.activationDate = moment().format(
                    "DD/MM/YYYY"
                );
            }
            $("#addMember").modal("show");
            $("#tabs .nav-pills a:first").tab("show");
        },
        enableDisableMember: function() {
            var disableMemberLoader = Ladda.create(
                document.querySelector(".disableMemberBtnLoader")
            );
            var memberCode = $("#memberRemoveConfirmModal").data("memberCode");
            var disable = $("#memberRemoveConfirmModal").data("disable");
            var url = disable
                ? "/member/disable/" + memberCode
                : "/member/enable/" + memberCode;
            disableMemberLoader.start();
            this.$http.post(url).then(
                (response) => {
                    if (response.body.hasError) {
                        $("#memberRemoveConfirmModal").modal("hide");
                        toastr["error"](response.body.message);
                        disableMemberLoader.stop();
                        disableMemberLoader.remove();
                        //                    temp check with message. TODO: change check with status/error code
                        if (
                            response.body.message ==
                            "Member Does Not Have Active Packages"
                        ) {
                            this.memberAssignpackage(memberCode);
                        }
                        return false;
                    }
                    $("#memberRemoveConfirmModal").modal("hide");
                    disableMemberLoader.stop();
                    disableMemberLoader.remove();
                    toastr["success"](response.body.message);
                    $("#refreshPageContents").trigger("click");
                },
                (response) => {
                    toastr["error"]("Something went wrong!", "Failed!");
                    disableMemberLoader.stop();
                    disableMemberLoader.remove();
                }
            );
        },
        showMemberConfirmation: function(memberCode, disable) {
            $("#memberRemoveConfirmModal .ConfMsg").addClass("hidden");
            if (disable) {
                $("#memberRemoveConfirmModal")
                    .find("#disableMember")
                    .removeClass("hidden");
            } else {
                $("#memberRemoveConfirmModal")
                    .find("#enableMember")
                    .removeClass("hidden");
            }
            $("#memberRemoveConfirmModal")
                .data("memberCode", memberCode)
                .data("disable", disable)
                .modal("show");
        },
        showMemberDeleteConfirmation: function(memberCode, type) {
            $("#memberDeleteConfirmModal")
                .data("memberCode", memberCode)
                .modal("show");
            if (
                type !== undefined &&
                type == "detail" &&
                !$("#lastPkgMsg").length
            ) {
                $("#memberDeleteConfirmModal .ConfMsg").prepend(
                    "<span id='lastPkgMsg'><b>You're deleting the only payment of the member. </b></span>"
                );
            } else if (type !== undefined && type != "detail") {
                $("#lastPkgMsg").remove();
            }
        },
        deleteMember: function() {
            var deleteMemberLoader = Ladda.create(
                document.querySelector(".deleteMemberBtnLoader")
            );
            var memberCode = $("#memberDeleteConfirmModal").data("memberCode");
            var disable = $("#memberDeleteConfirmModal").data("disable");
            var url = "/member/delete/" + memberCode;
            deleteMemberLoader.start();
            this.$http.post(url).then(
                (response) => {
                    if (response.body.hasError) {
                        $("#memberDeleteConfirmModal").modal("hide");
                        toastr["error"](response.body.message);
                        deleteMemberLoader.stop();
                        deleteMemberLoader.remove();
                        return false;
                    }
                    $("#memberDeleteConfirmModal").modal("hide");
                    deleteMemberLoader.stop();
                    deleteMemberLoader.remove();
                    toastr["success"](response.body.message);
                    if (typeof appMembers !== "undefined") {
                        appMembers.getVueItems(1);
                    } else {
                        window.location.href = "/members";
                    }
                    //$("#refreshPageContents").trigger('click');
                },
                (response) => {
                    toastr["error"]("Something went wrong!", "Failed!");
                    deleteMemberLoader.stop();
                    deleteMemberLoader.remove();
                }
            );
        },
        showMemberPaymentDeleteConfirmation: function(userPaymentCode) {
            $("#memberPaymentDeleteConfirmModal")
                .data("userPaymentCode", userPaymentCode)
                .modal("show");
        },
        showPreviousPackageDetails: function(previousUserPackageCode) {
            this.$http
                .get("/member/package/detail/" + previousUserPackageCode)
                .then((response) => {
                    if (!response.body.hasError) {
                        appMemberDetails.previousPackageData =
                            response.body.result;
                        $("#packageUpgradedDetails")
                            .data("userPackageCode", previousUserPackageCode)
                            .modal("show");
                    }
                });
        },
        deleteMemberPayment: function() {
            var deleteMemberPaymentLoader = Ladda.create(
                document.querySelector(".deleteMemberPaymentBtnLoader")
            );
            var userPaymentCode = $("#memberPaymentDeleteConfirmModal").data(
                "userPaymentCode"
            );
            var disable = $("#memberPaymentDeleteConfirmModal").data("disable");
            var url = "/member/payment/delete";
            deleteMemberPaymentLoader.start();
            this.$http
                .post(url, {
                    paymentCode: userPaymentCode,
                })
                .then(
                    (response) => {
                        if (response.body.hasError) {
                            $("#memberPaymentDeleteConfirmModal").modal("hide");
                            toastr["error"](response.body.message);
                            deleteMemberPaymentLoader.stop();
                            deleteMemberPaymentLoader.remove();
                            return false;
                        }
                        $("#memberPaymentDeleteConfirmModal").modal("hide");
                        deleteMemberPaymentLoader.stop();
                        deleteMemberPaymentLoader.remove();
                        toastr["success"](response.body.message);
                        if (appMemberDetails !== undefined) {
                            appMemberDetails.getMemberDetails();
                        }
                    },
                    (response) => {
                        toastr["error"]("Something went wrong!", "Failed!");
                        deleteMemberPaymentLoader.stop();
                        deleteMemberPaymentLoader.remove();
                    }
                );
        },
        openAddMemberModal: function() {
            topMemberActionBtnApp.openAddMember();
        },
        openUpgradeMemberPackage: function(
            userPackageCode,
            packageName,
            totalAmt,
            paidAmt,
            dueAmt
        ) {
            var tabForm = require("../tabForm");
            var argsReset = {
                tabUlIdName: "guide-tabs",
                formIdName: "addMemberForm",
                mainWrappersClassName: "formTabWrappers",
            };
            tabForm.setToFirstTab(argsReset);
            addMember.resetAddMemberForm();
            $("#mb-pkg-addedit").text("Proceed");
            $("form label.error").hide();
            memberFormTabsSettings.tabsCount = 2;
            addMember.headerMessage = "Upgrade Package";
            addMember.type = "upgradePackage";
            addMember.upgradePackgeInfo.packageName = packageName;
            addMember.upgradePackgeInfo.totalAmount = totalAmt;
            addMember.upgradePackgeInfo.paidAmount = paidAmt;
            addMember.upgradePackgeInfo.dueAmount = dueAmt;
            addMember.upgradePackgeInfo.userPackageCode = userPackageCode;
            addMember.memberData.packageType = "Membership";
            addMember.getUpgradeToPackageList(userPackageCode);
            $("#tabs .nav-pills a:first").tab("show");
            $("#addMember").modal("show");
        },
        reverificationMail(code, value) {
            this.$Progress.start();
            let data = {
                userCode: code,
                identifier: value,
            };
            this.$http
                .post("/member/identifier/verify/request", data)
                .then((response) => {
                    if (!response.body.hasError) {
                        this.$Progress.finish();
                        toastr["success"](response.data.message);
                    } else {
                        this.$Progress.finish();
                        toastr["error"](response.data.message);
                    }
                });
        },
    },
});
window.topMemberActionBtnApp = new Vue({
    el: "#topMemberActionBtn",
    methods: {
        openAddMember: function() {
            var tabForm = require("../tabForm");
            var argsReset = {
                tabUlIdName: "guide-tabs",
                formIdName: "addMemberForm",
                mainWrappersClassName: "formTabWrappers",
            };
            tabForm.setToFirstTab(argsReset);
            $("#mb-pkg-addedit").text("Proceed");
            memberFormTabsSettings.tabsCount = 3;
            addMember.memberVerificationError = "";
            addMember.resetAddMemberForm();
            validate.resetFormValidationErrors("addMemberForm");
            addMember.headerMessage = "Add Member";
            addMember.type = "add";
            $(".autoCapitalize").keyup();
            $("#addMember").modal("show");
            $("#tabs .nav-pills a:first").tab("show");
            $("#memEmail").attr("readonly", false);
            $("#memMobile").attr("readonly", false);
            $(".hideOnLeads").show();
        },
    },
});
